module.exports = __webpack_public_path__ + "static/media/dynamic_pic.4558c31a.png";